var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 7.33268C12.5003 6.0066 11.9735 4.73483 11.0359 3.79715C10.0982 2.85947 8.82641 2.33268 7.50033 2.33268C6.17424 2.33268 4.90247 2.85947 3.96479 3.79715C3.02711 4.73483 2.50033 6.0066 2.50033 7.33268V13.9993H12.5003V7.33268ZM14.167 14.5552L14.5003 14.9994C14.5468 15.0613 14.575 15.1349 14.582 15.2119C14.5889 15.289 14.5743 15.3665 14.5397 15.4357C14.5051 15.5049 14.4519 15.5631 14.386 15.6038C14.3202 15.6445 14.2444 15.666 14.167 15.666H0.833659C0.756279 15.666 0.680428 15.6445 0.614604 15.6038C0.548781 15.5631 0.495586 15.5049 0.460981 15.4357C0.426376 15.3665 0.411727 15.289 0.418676 15.2119C0.425625 15.1349 0.453898 15.0613 0.500326 14.9994L0.833659 14.5552V7.33268C0.833659 5.56457 1.53604 3.86888 2.78628 2.61864C4.03652 1.36839 5.73222 0.666016 7.50033 0.666016C9.26844 0.666016 10.9641 1.36839 12.2144 2.61864C13.4646 3.86888 14.167 5.56457 14.167 7.33268V14.5552ZM5.41699 16.4993H9.58366C9.58366 17.0519 9.36417 17.5818 8.97347 17.9725C8.58276 18.3632 8.05286 18.5827 7.50033 18.5827C6.94779 18.5827 6.41789 18.3632 6.02719 17.9725C5.63649 17.5818 5.41699 17.0519 5.41699 16.4993Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d8a346ee9f5331f2bd075df2128f4e18.svg";
export { ForwardRef as ReactComponent };